<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="fmad" id="ack"><a href="#/c7#ack1"><i>Acknowledgments</i></a></p>
<blockquote>
<div>
<p class="tx1">I’d like to thank the following people who have given me help of one kind or another while I was writing this book:</p>
<p class="tx">Angela Hendrix, Kathleen Kern, Barbara Kingsbury, Andrew Langman, Travis MacCaskill, Faith Manney, Patricia Pelrine, Charles Rhyne, Nancy Santos, Marion Scepansky, Dave Snyder, Michael Taeckens, Jim Teal, and Nathan Watters.</p>
</div>
</blockquote>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c8.vue?32962f06